/* tslint:disable */
/* eslint-disable */
/**
 * Store
 * 店舗向けAPI
 *
 * The version of the OpenAPI document: 1.0
 * Contact: kiuchi@wcdi.co.jp
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { ResponseSuccessWithPagingAllOfMeta } from './ResponseSuccessWithPagingAllOfMeta';
import {
    ResponseSuccessWithPagingAllOfMetaFromJSON,
    ResponseSuccessWithPagingAllOfMetaFromJSONTyped,
    ResponseSuccessWithPagingAllOfMetaToJSON,
} from './ResponseSuccessWithPagingAllOfMeta';

/**
 * 
 * @export
 * @interface ResponseSuccessWithPaging
 */
export interface ResponseSuccessWithPaging {
    /**
     * 
     * @type {object}
     * @memberof ResponseSuccessWithPaging
     */
    data: object;
    /**
     * 
     * @type {ResponseSuccessWithPagingAllOfMeta}
     * @memberof ResponseSuccessWithPaging
     */
    meta: ResponseSuccessWithPagingAllOfMeta;
}

/**
 * Check if a given object implements the ResponseSuccessWithPaging interface.
 */
export function instanceOfResponseSuccessWithPaging(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "data" in value;
    isInstance = isInstance && "meta" in value;

    return isInstance;
}

export function ResponseSuccessWithPagingFromJSON(json: any): ResponseSuccessWithPaging {
    return ResponseSuccessWithPagingFromJSONTyped(json, false);
}

export function ResponseSuccessWithPagingFromJSONTyped(json: any, ignoreDiscriminator: boolean): ResponseSuccessWithPaging {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'data': json['data'],
        'meta': ResponseSuccessWithPagingAllOfMetaFromJSON(json['meta']),
    };
}

export function ResponseSuccessWithPagingToJSON(value?: ResponseSuccessWithPaging | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'data': value.data,
        'meta': ResponseSuccessWithPagingAllOfMetaToJSON(value.meta),
    };
}

